export default "__VITE_ASSET__CwcXsh42__"